import PokemonList from "./FavoritesList";

export default PokemonList;
